const state = {
    notification: [],
    pushnotification:[],
    loading: false
};

export default state;